import React from 'react';
/* eslint-disable react/prop-types,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
// Defined in general.js
/* global scrollToPageTop */
/* global Uri */

import Filters from './filters.js';
import SearchResults from './searchResults.js';
import SortSelector from './sortSelector.js';
import Breadcrumb from './breadcrumb.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { Svg } from '../common/Svg.js';
import MobileSearchHeader from './MobileSearchHeader.js';
import PickAProject from './pickAProject.js';
import { mapFeatureCalloutUtils } from './mapFeatureCalloutUtils.js';
import { LocationSearchBox } from '../common/locationSearchBox.js';
import { KeywordSearchBox } from '../common/KeywordSearchBox.js';
import { addCommas } from '../utils/numberUtils.ts';
import usePrimarySearchData from './usePrimarySearchData.js';
import { closeMenuLinks } from '../general/module/headerModule';

let SearchLayoutMobile = (props) => {
    const toggleFiltersView = props.callbacks.toggleMobileFilters;
    const oldSearchURL = React.useRef();
    const [pendingKeywords, setPendingKeywords] = React.useState();
    const { totalResults, essentialsOnly } = usePrimarySearchData(props.projects);
    const loadingItems = [];

    for(let i = 0; i < 13; i++){
        if(i != 5) {
            loadingItems.push(
                <div className="skeleton-card">
                    <div className="right">
                        <div className="skeleton-title"></div>
                        <div className="skeleton-body"></div>
                        <div className="skeleton-location"><div className="skeleton-school-name"></div> <div className="skeleton-city-name"></div></div>
                    </div>
                </div>
            );
        } else {
            loadingItems.push(
                <div className="essentials-section">
                    <div className="essentials-header"><h3>Add-on basics for a teacher nearby</h3></div>
                    <div className="selected-essentials">
                        <a className="essentials-list-card">
                            <div className="essentials-description">
                                <div className="top-supply"></div>
                                <div className="list-details">
                                    <div><h3 className="header"></h3>
                                        <span className="teacher-secondary-info"></span>
                                    </div>
                                </div>
                            </div>
                            <button className="button-primary small essentials"><span className="name">Add to cart</span><span className="price">$10</span></button>
                        </a>
                        <a className="essentials-list-card">
                            <div className="essentials-description">
                                <div className="top-supply"></div>
                                <div className="list-details">
                                    <div><h3 className="header"></h3>
                                        <span className="teacher-secondary-info"></span>
                                    </div>
                                </div>
                            </div>
                            <button className="button-primary small essentials"><span className="name">Add to cart</span><span className="price">$10</span></button>
                        </a>
                    </div>
                </div>
            );
        }
    }

    function openFiltersView() {
        // We need to close the global header menu
        // If we don't, it covers up part of the filter view
        closeMenuLinks(0);
        toggleFiltersView();
        oldSearchURL.current = props.searchURL;
    }

    function closeFilterView() {
        toggleFiltersView();
        oldSearchURL.current = null;
        scrollToPageTop();
    }

    function revertFilters() {
        props.callbacks.changeURL(oldSearchURL.current);
        closeFilterView();
    }

    function makePickAProject() {
        const url = new Uri(props.searchURL);
        const showPickAProject = !url.hasQueryParam('historical', 'true') && (props.projects.totalProposals > 1);
        if (showPickAProject) {
            return (
                <div className='pick-project-section'>
                    <h5>Not sure what to choose?</h5>
                    <PickAProject searchURL={props.searchURL}/>
                </div>
            );
        }
    }

    if (props.showMobileFilters) {
        let applyButton;
        // Only display the search button if there are changes to apply
        if (props.searchURL !== oldSearchURL.current || pendingKeywords) {
            applyButton = (
                <span className='button-primary' onClick={closeFilterView}>
                    See Projects
                </span>
            );
        }

        return (
            <div className="search-filters">
                <div>
                    <span onClick={revertFilters}>
                        <Svg icon="delete" additionalClasses="is-button"/>
                    </span>
                    <span>
                        {/* eslint-disable-next-line eqeqeq */}
                        <strong>{addCommas(totalResults)} {essentialsOnly ? 'request' : 'project'}{totalResults != '1' ? 's' : ''}</strong>
                    </span>
                    {applyButton}
                </div>
                <div>
                    <div className="form-redux search-area">
                        <h4>Search</h4>
                        <KeywordSearchBox {...props} searchOnBlur={true} setPendingKeywords={setPendingKeywords} />
                        <LocationSearchBox {...props} />
                    </div>
                    <Filters {...props} />
                </div>
            </div>
        );
    } else {
        const isLoggedInTeacher = props.user && props.user.userType === 'teacher';

        return (
            <div className="search-results">
                <MobileSearchHeader {...props} targetUrl={mapFeatureCalloutUtils.getMapFeatureUrl(props.searchURL)} openFiltersView={openFiltersView} />

                {props.callbacks.isLoading() ? <LoadingEllipsis className="page-loader"/> : ''}
                <div className="search-body">
                    { isLoggedInTeacher ? <div><div className="cartcopy-container"><span>Teachers, you can copy most project carts when you&apos;re browsing! Just select &ldquo;Copy this cart.&rdquo;</span> <a className="cc-banner-link" href={`${baseURL}donors/search.html?solrQuery=approveddate:[now-90d/d%20TO%20now]`}>See all project carts you can copy</a></div></div> : '' }
                    <div className="standard-search">
                        <Breadcrumb {...props} />
                        <SortSelector {...props} />
                    </div>
                    {props.callbacks.isLoading() ? <div className="loading-skeleton">{loadingItems}</div> : <SearchResults {...props} />}
                    {makePickAProject()}
                </div>
            </div>
        );
    }
};
SearchLayoutMobile = React.memo(SearchLayoutMobile);
export default SearchLayoutMobile;
